import React from "react";
import { Route, Routes } from "react-router-dom";
import SalesDashboard from "./sales";
import SalesProducts from "./sales-products";
import CustomerSegmentsDashboard from "./customer-segments";
import RFMDashboard from "./rfm";
import RFMAnalysisDetail from "./rfm/RFMAnalysisDetail";
import MarketingMetricsDashboard from "./marketing-metrics";
import CampaignReportsDashboard from "./campaign-reports";

const Reports = () => {
  return (
    <Routes>
      <Route path="sales" element={<SalesDashboard />} />
      <Route path="sales/products" element={<SalesProducts />} />
      <Route path="customer-segments" element={<CustomerSegmentsDashboard />} />
      <Route path="rfm" element={<RFMDashboard />} />
      <Route path="rfm/:analysisId" element={<RFMAnalysisDetail />} />
      <Route path="marketing-metrics" element={<MarketingMetricsDashboard />} />
      <Route path="campaign-reports" element={<CampaignReportsDashboard />} />
    </Routes>
  );
};

export default Reports;
